module.exports = __webpack_public_path__ + "img/img1.355cf5c7.png";